import { render } from "./TotCourse.vue?vue&type=template&id=6606e4cf&ts=true"
import script from "./TotCourse.vue?vue&type=script&lang=ts"
export * from "./TotCourse.vue?vue&type=script&lang=ts"

import "./TotCourse.vue?vue&type=style&index=0&id=6606e4cf&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__